<template>
  <div>
    <template
      v-if="
        fields &&
        fields.link &&
        fields.link.value &&
        fields.link.value.href &&
        fields.link.value.href.length > 0
      "
    >
      <sc-link
        v-if="fields && fields.link"
        :field="fields.link"
        class="image-carousel__link"
        :class="fields.link.value.class"
      >
        <div class="carousel-item__wrapper">
          <sc-image
            v-if="fields && fields.image"
            :media="fields.image"
            class="image-carousel__image"
            :class="{ padding: fields.padding.value === true }"
          />
          <div
            v-if="fields && fields.center && fields.padding"
            class="image-carousel__content"
            :class="[
              { center: fields.center.value === true },
              { padding: fields.padding.value === true }
            ]"
          >
            <sc-text
              tag="div"
              class="image-carousel__heading"
              v-if="fields && fields.headline"
              :field="fields.headline"
            />
            <sc-text
              tag="div"
              class="image-carousel__subheading"
              v-if="fields && fields.subheadline"
              :field="fields.subheadline"
            />
            <sc-text
              tag="div"
              class="image-carousel__desc"
              v-if="fields && fields.description"
              :field="fields.description"
            />
          </div>
        </div>
      </sc-link>
    </template>
    <template v-else>
      <div class="carousel-item__wrapper">
        <sc-image
          v-if="fields && fields.image"
          :media="fields.image"
          class="image-carousel__image"
          :class="{ padding: fields.padding.value === true }"
        />
        <div
          v-if="fields && fields.center"
          class="image-carousel__content"
          :class="[
            { center: fields.center.value === true },
            { padding: fields.padding.value === true }
          ]"
        >
          <sc-text
            tag="div"
            class="image-carousel__heading"
            v-if="fields && fields.headline"
            :field="fields.headline"
          />
          <sc-text
            tag="div"
            class="image-carousel__subheading"
            v-if="fields && fields.subheadline"
            :field="fields.subheadline"
          />
          <sc-text
            tag="div"
            class="image-carousel__desc"
            v-if="fields && fields.description"
            :field="fields.description"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { Text, Image, Link } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Image-Carousel-Item',
  components: {
    ScText: Text,
    ScImage: Image,
    ScLink: Link
  },
  props: {
    fields: {
      type: Object
    }
  }
};
</script>
<style lang="scss" scoped>
.image-carousel {
  &__link {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    // Hide Text
    text-indent: 100%;
    white-space: nowrap;
    overflow: hidden;
  }

  &__image {
    width: calc(100% - 2rem);
    margin: 0 1rem;
    height: auto;

    &.padding {
      width: calc(100% - 7rem);
      margin: 0 3.5rem;

      @include phone-only {
        width: 120px;
        margin: auto;
      }

      @include desktop-up {
        width: calc(100% - 12rem);
        margin: 0 6rem;
      }
    }
  }

  &__content {
    display: inline-block;

    & & {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
    }

    &.padding {
      padding: 2rem 1rem 0;
    }
  }

  &__heading {
    display: block;
    @include font-styles('Arial', 2.4rem, 200, normal, 2.8rem, 0, $blue);
    margin-top: 2rem;
  }

  &__subheading {
    display: block;
    @include font-styles('Arial', 1.8rem, 300, normal, 2.6rem, 0, $dark-blue);
    margin-top: 1rem;
  }

  &__desc {
    display: block;
    @include font-styles('Arial', 1.8rem, 100, normal, 2.4rem, 0, $dark-blue);
    padding: 0;
    margin-top: 1rem;
  }

  .center {
    text-align: center;
    align-content: center;
  }
}

a {
  &.image-carousel__link {
    &:hover {
      div {
        &.image-carousel__desc {
          text-decoration: underline;
          text-decoration-color: $dark-blue;
          text-decoration-thickness: 1px;
        }
      }
    }
    line-height: 0;
    font-size: 0;
    color: transparent;
  }
}
.carousel-item__wrapper {
  display: grid;
  position: relative;
  z-index: -1;

  text-indent: initial;
  white-space: normal;
  overflow: initial;
}
</style>
